// extracted by mini-css-extract-plugin
export var notificationHost = "_if-0";